module.exports = __webpack_public_path__ + "static/media/zoom_in_on.7eddcfb6.svg";